<template>
  <a-layout-content>
    <div class="lg:container lg:mx-auto lg:px-56 my-2 px-10">
      <a-form-model ref="form" :model="lead" :rules="leadRules">
        <h1 class="font-bold text-2xl text-blue-500 mt-6">Cotiza tu crédito</h1>
        <!-- <a-page-header title="¿Cómo Usarás tu Crédito?" sub-title="Selecciona un producto de a continuación" /> -->
        <separator title="¿Cómo usarás tu crédito?" description="Selecciona de las siguientes opciones la forma en que usarás tu crédito." symbols="*" />
        <product-list @changed="onProductChanged" />
        <!-- <div class="mx-auto text-left px-5 py-4">
          <span class="font-bold text-xl pr-3">¿Cómo te gustaría comprobar ingresos?</span>
          <span :style="{ color: 'rgba(0, 0, 0, 0.45)' }">Selecciona un comprobante de ingresos</span>
        </div> -->
        <separator class="mt-4" title="¿Cuánto dinero necesitas?" description="El valor mínimo es de $5,000 y él max. $120,000" symbols="*" />
        <a-col class="w-3/4 justify-center mx-auto my-2" type="flex">
          <a-row class="ml-8" flex="100px">
            <a-input-number
              class="w-full sm:w-1/2 border-blue-500 border-2 rounded-lg"
              v-model="lead.requestedAmount"
              :min="amountConfig.minAmount"
              :max="amountConfig.maxAmount"
              :step="amountConfig.step"
              :formatter="formatMoney"
              :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
              size="large"
            />
          </a-row>
          <!-- <a-row flex="auto">
            <a-slider v-model="lead.requestedAmount" :min="amountConfig.minAmount" :max="amountConfig.maxAmount" :step="amountConfig.step" :marks="amountConfig.marks" :tip-formatter="formatMoney" />
          </a-row> -->
          <!-- <spa class="font-semibold">La cantidad puede ser entre $5,000 hasta $120,000 pesos</spa> -->
        </a-col>
        <separator title="¿En cuántas quincenas pagarás tu crédito?" description="Selecciona el plazo de tu crédito a pagar quincenalmente." symbols="*" />
        <a-radio-group class="lg:mb-2" default-value="a" button-style="solid" v-model="lead.selectedPeriod" @change="onPayPeriodChange" size="large">
          <a-radio-button v-for="term in terms" :key="term" :value="term">{{ term }}</a-radio-button>
        </a-radio-group>
        <div class="text-base"
          ><span class="font-semibold">Pago Quincenal:</span> $
          {{
            lead.fixedRecurrentPayment
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }}</div
        >
        <div class="text-base"><span class="font-semibold">CAT:</span> {{ lead.calculatedCat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}% SIN IVA</div>

        <!--<separator title="¿Cómo te gustaría comprobar ingresos?" description="Elige el comprobante de ingresos que usarás para tu solicitud." symbols="*" />
        <a-form-model-item class="w-full lg:w-3/4 mx-auto" prop="incomeProofId">
          <a-select class="border-blue-500 border-2 rounded-lg" placeholder="Selecciona un comprobante de ingresos" size="large" v-model="lead.incomeProofId">
            <a-select-option v-for="ci in incomeProofs" :key="ci.id" :value="ci.id">{{ ci.name }}</a-select-option>
          </a-select>
        </a-form-model-item>-->

        <separator title="¿Cuál es tu tipo de ingreso?" description="Elige el tipo de ingreso que usarás para tu solicitud." symbols="*" />
        <a-form-model-item class="w-full lg:w-3/4 mx-auto" prop="incomeTypeId">
          <a-select class="border-blue-500 border-2 rounded-lg" placeholder="Selecciona un tipo de ingreso" size="large" v-model="lead.incomeTypeId" @change="onIncomeTypeChange">
            <a-select-option v-for="income in incomeTypes" :key="income.id" :value="income.id">{{ income.name }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <separator title="¿Cuál es el destino de los recursos?" description="Elige el destino de los recursos de tu solicitud." symbols="*" />
        <a-form-model-item class="w-full lg:w-3/4 mx-auto" prop="purposeResources">
          <a-select class="border-blue-500 border-2 rounded-lg" placeholder="Selecciona un destino de los recursos" size="large" v-model="lead.purposeResources">
            <a-select-option v-for="pt in purposeTypes" :key="pt.value" :value="pt.value">{{ pt.text }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <separator class="mt-4" title="Cuéntanos un poco sobre tí" description="En esta parte solo necesitamos que nos des tus datos personales, tal y como aparecen en tus documentos oficiales." />
        <div class="w-full lg:w-3/4 justify-center mx-auto my-2">
          <a-row :gutter="12">
            <a-col flex="auto" class="w-full lg:float-left lg:w-1/2">
              <a-form-model-item class="my-2 border-0" prop="firstName">
                <label class="block w-full text-left pl-3 font-medium">Nombre <span class="text-red">*</span></label>
                <a-input class="border-blue-500 border-2 rounded-lg" v-model.trim="lead.firstName" name="firstname" placeholder="Nombre" allow-clear size="large" tabindex="5" v-uppercase v-spanish>
                  <a-icon slot="prefix" type="user" />
                  <a-tooltip slot="suffix" title="Primer nombre como aparece en tu identificación oficial">
                    <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
                  </a-tooltip>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col flex="auto" class="w-full lg:float-left lg:w-1/2">
              <a-form-model-item class="my-2 border-0" prop="middleName">
                <label class="block w-full text-left pl-3 font-medium">Segundo nombre</label>
                <a-input
                  class="border-blue-500 border-2 rounded-lg"
                  v-model.trim="lead.middleName"
                  name="middleName"
                  placeholder="Segundo nombre"
                  allow-clear
                  size="large"
                  tabindex="5"
                  v-uppercase
                  v-spanish
                >
                  <a-tooltip slot="suffix" title="Segundo nombre como aparece en tu identificación oficial">
                    <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
                  </a-tooltip>
                </a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col flex="auto" class="w-full lg:float-left lg:w-1/2">
              <a-form-model-item class="my-2 border-0" prop="lastName">
                <label class="block w-full text-left pl-3 font-medium">Apellido paterno <span class="text-red">*</span></label>
                <a-input
                  class="border-blue-500 border-2 rounded-lg"
                  v-model.trim="lead.lastName"
                  name="lastname"
                  placeholder="Apellido paterno"
                  allow-clear
                  size="large"
                  tabindex="6"
                  v-uppercase
                  v-spanish
                >
                  <a-tooltip slot="suffix" title="Apellido paterno como aparece en tu identificación oficial">
                    <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
                  </a-tooltip>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col flex="auto" class="w-full lg:float-left lg:w-1/2">
              <a-form-model-item class="my-2 border-0" prop="mothersLastName">
                <label class="block w-full text-left pl-3 font-medium">Apellido materno</label>
                <a-input class="border-blue-500 border-2 rounded-lg" v-model.trim="lead.mothersLastName" placeholder="Apellido materno" allow-clear size="large" tabindex="7" v-uppercase v-spanish>
                  <a-tooltip slot="suffix" title="Apellido materno como aparece en tu identificación oficial">
                    <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
                  </a-tooltip>
                </a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col flex="auto" class="w-full lg:float-left lg:w-1/2">
              <a-form-model-item class="my-2 border-0" prop="email">
                <label class="block w-full text-left pl-3 font-medium">Correo electrónico <span class="text-red">*</span></label>
                <a-input
                  class="border-blue-500 border-2 rounded-lg"
                  v-model.trim="lead.email"
                  name="email"
                  type="email"
                  placeholder="ejemplo@mesajeria.com"
                  allow-clear
                  size="large"
                  tabindex="9"
                  v-lowercase
                >
                  <a-icon slot="prefix" type="mail" />
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col flex="auto" class="w-full lg:float-left lg:w-1/2">
              <a-form-model-item class="my-2 border-0" prop="mobile">
                <label class="block w-full text-left pl-3 font-medium">Número de teléfono móvil <span class="text-red">*</span></label>
                <a-input
                  class="border-blue-500 border-2 rounded-lg"
                  v-model="lead.mobile"
                  name="phone"
                  type="tel"
                  placeholder="Número de teléfono móvil"
                  :max-length="10"
                  allow-clear
                  size="large"
                  tabindex="10"
                  v-numeric-only
                >
                  <a-icon slot="prefix" type="phone" />
                </a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12"> </a-row>
          <div class="mt-2">
            Al <span class="font-bold">registrar tus datos y comenzar la solicitud</span> aceptas los
            <!-- <router-link class="underline" to="/terms-conditions" target="_blank">Términos y Condiciones y Aviso de Privacidad</router-link>. -->
            <span class="underline text-blue-700 cursor-pointer" @click.prevent="TyCVisible = true">Términos y Condiciones y Aviso de Privacidad.</span>.
          </div>
          <!-- MODAL TERMINOS Y CONDICIONES -->
          <a-modal :visible="TyCVisible" @ok="TyCVisible = false" @cancel="TyCVisible = false" okText="Regresar" id="modalTyC">
            <h1 class="font-bold">TÉRMINOS Y CONDICIONES</h1>
            <br />
            <h2 class="font-bold">Condiciones de uso</h2>
            <p style="text-align: justify">
              El Usuario acepta que por el simple hecho de acceder a este Sitio, acepta los términos y condiciones que aquí se describen. Libertad Servicios Financieros S.A. de C.V., S.F.P.
              (LIBERTAD), se reserva el derecho de modificar el contenido del Sitio en cualquier momento, sin necesidad de previo aviso. El Usuario conviene en no utilizar dispositivos, software, o
              cualquier otro medio tendiente a interferir tanto en las actividades y/u operaciones del Sitio y/o de LIBERTAD, o en las bases de datos y/o información que se contenga en el mismo. El
              Usuario acepta expresamente que cualquier intromisión, tentativa o actividad violatoria o contraria a la leyes sobre derechos de autor, de propiedad intelectual, secreto bancario, y/o a
              las prohibiciones aquí estipuladas, lo harán susceptible de responsabilidad civil, penal o cualquier otra aplicable, y LIBERTAD tendrá el derecho de ejercitar las acciones legales
              pertinentes en su contra. Asimismo, en tal caso el Usuario será responsable de indemnizar los daños y perjuicios ocasionados a LIBERTAD. El Usuario conviene en que las violaciones de
              seguridad a los sistemas de cómputo y/o redes están prohibidas, y pueden generar delitos en materia penal y en su caso en responsabilidad civil. El Sitio es para uso exclusivo del
              Usuario, por lo que éste no podrá lucrar de manera alguna con los servicios financieros ofrecidos en el Sitio.
            </p>
            <br />
            <h2 class="font-bold">Confidencialidad</h2>
            <p style="text-align: justify"> Toda la información que LIBERTAD recabe del Usuario es tratada con absoluta privacidad conforme las disposiciones legales aplicables. </p>
            <br />
            <h2 class="font-bold">Sitios vinculados</h2>
            <p style="text-align: justify">
              Cualquier vinculación con otro sitio, ya sea mediante ligas (links), marcos (frames) o de cualquier otra forma, que no se encuentre autorizada expresamente por LIBERTAD, será prohibida,
              por lo que LIBERTAD se reserva el derecho de desactivar del Sitio cualquier liga o marco no autorizado. De la misma forma, LIBERTAD no asume responsabilidad alguna respecto del contenido
              de cualquier sitio ligado o vinculado con el Sitio. Asimismo, el Usuario reconoce que cualquier acceso a otro sitio vinculado o ligado, será bajo su exclusiva responsabilidad, y en ese
              acto libera a LIBERTAD de toda responsabilidad derivada de cualquier asunto relacionado con dicho acceso.
            </p>
            <br />
            <h2 class="font-bold">Fallas en el sistema</h2>
            <p style="text-align: justify">
              LIBERTAD no se responsabiliza por cualquier daño, perjuicio o pérdida en el equipo del Usuario causada por fallas en los sistemas de LIBERTAD, en su servidor, o en la Internet. Asimismo,
              LIBERTAD no será responsable por cualquier virus que pudiera infectar el equipo del Usuario como consecuencia del acceso, uso o examen del Sitio o a raíz de cualquier transferencia de
              datos, archivos, imágenes, textos, o audio contenidos en el mismo. Los Usuarios no podrán imputar a LIBERTAD responsabilidad alguna ni exigirle a ésta indemnización por daños o
              perjuicios, resultantes de dificultades técnicas o fallas en los sistemas de LIBERTAD, o en los medios electrónicos como la Internet.
            </p>
            <br />
            <h2 class="font-bold">Propiedad intelectual e industrial</h2>
            <p style="text-align: justify">
              Los programas, bases de datos, redes y archivos que permiten al Usuario acceder y usar el Sitio, son propiedad de LIBERTAD y están protegidos por las leyes y tratados internacionales de
              derechos de autor, marcas, patentes, modelos y diseños industriales. El uso indebido y/o la reproducción total o parcial del contenido de los mismos queda prohibido, y dichas acciones se
              encuentran sujetas a sanciones civiles y penales, y serán objeto de todas las acciones judiciales pertinentes. Cualquier Usuario que tenga acceso al Sitio o a la información contenida en
              el mismo, reconoce expresamente que LIBERTAD, es la titular, propietaria y/o legítima licenciataria, de cualquier información que se encuentre en el Sitio, así como de cualquier marca,
              aviso, nombre comercial, logotipo o cualquier otro derecho de propiedad industrial o derecho de autor que aparezca en el Sitio. Asimismo, el Usuario reconoce que LIBERTAD ha sido el
              desarrollador de los conceptos de libertad.com.mx y micreditolibertad.com, por lo que es del conocimiento delUsuario que dicha información y/o conceptos se encuentran protegidos por las
              leyes mexicanas y por los tratados internacionales de derechos de autor, por lo que cualquier reproducción, modificación, alteración, aprovechamiento o cualquier otro uso que se le dé a
              dicha información y/o conceptos, se encuentra prohibido, y en este acto el Usuario del Sitio o cualquier persona que tenga acceso a la información antes señalada, se obliga a indemnizar
              a LIBERTAD con respecto de cualquier violación a lo estipulado en el presente párrafo, ya sea en México o en el extranjero.
            </p>
            <br />
            <h2 class="font-bold">Aviso de privacidad corto (en términos del decimoprimero de los lineamientos del aviso de privacidad)</h2>
            <p style="text-align: justify">
              Libertad Servicios Financieros, S.A. de C.V., S.F.P., con domicilio en Avenida Heroico Colegio Militar No. 67, Colonia El Pueblito, Municipio de Corregidora, Querétaro, C.P. 76900,
              responsable del tratamiento de sus datos personales, con las finalidades de: desarrollo, análisis, comercialización, asesoría, promoción, contratación, colocación, identificación de
              riesgo en la contratación, diseño de productos y servicios financieros y las obligaciones derivadas de la relación jurídica entre el titular de datos personales y LIBERTAD. De igual
              forma, para el caso de utilizar la plataforma de “Precalificación de Crédito en Línea”, se hace de su conocimiento que LIBERTAD podrá transferir los datos recabados al tercero denominado
              KOSMOS, para el proceso de precalificación. Asimismo, se podrán recabar datos personales sensibles. Consulte nuestro aviso de privacidad integral en www.libertad.com.mx o en cualquier
              sucursal.
            </p>
            <br />
            <h2 class="font-bold">Consulta en sociedad de información crediticia</h2>
            <p style="text-align: justify">
              Para llevar a cabo el registro de pre solicitudes de crédito, autorizo expresamente a LIBERTAD para que lleve a cabo las Investigaciones necesarias, sobre mi comportamiento crediticio o
              el de la Empresa que represento, en la Sociedad de Información Crediticia que Libertad haya seleccionado para tal efecto, de manera enunciativas más no limitativa en Trans Union de
              México, S. A. SIC, Dun And Bradstreet, S.A. SIC y Círculo de Crédito S.A., S.I.C. Asimismo, me hago sabedor de la naturaleza y alcance de las sociedades de información crediticia y de la
              información contenida en los reportes de crédito y reporte de crédito especial, así como del uso que LIBERTAD hará de tal información y de que ésta podrá realizar consultas periódicas
              sobre mi historial o el de la empresa que represento, consintiendo que esta autorización se encuentre vigente por un período de 3 años contados a partir de su expedición y en todo caso
              durante el tiempo que se mantenga la relación jurídica.
            </p>
          </a-modal>
          <!-- FIN MODAL TERMINOS Y CONDICIONES -->
        </div>
        <a-alert
          class="mt-5 mb-5 mx-auto max-w-2xl"
          v-if="noProductSelectedError"
          type="error"
          message="Selecciona la forma en que usarás tu crédito antes de comenzar con tu solicitud."
          closable
          @close="noProductSelectedError = false"
        />
        <a-button
          class="mt-2 w-48 md:w-64 h-10 mx-2 rounded-lg bg-color-yellow text-base md:text-lg font-bold border-0 text-white align-middle hover:bg-yellow-600 hover:text-white"
          type="secondary"
          size="large"
          @click.prevent="submit"
          :loading="isBusy"
          :disabled="disableSendNips || isDisabled"
        >
          Comenzar mi solicitud
        </a-button>
      </a-form-model>
    </div>

    <a-modal
      v-model="showCodeConfirmation"
      title="Código Verificador"
      @ok.prevent="verifyNipCode"
      @cancel.prevent="showCodeConfirmation = false"
      cancelText="Cancelar"
      okText="Validar"
      :confirm-loading="isCodeConfirmationBusy"
      :cancelButtonProps="{ props: { disabled: isCodeConfirmationBusy } }"
      :maskClosable="mask"
    >
      <p>Ingresa el código verificador que se te ha enviado por SMS</p>
      <a-input class="mt-2 border-blue-500 border-2 rounded-lg" v-model="confirmationCode" type="password" placeholder="Código verificador" size="large">
        <a-tooltip slot="suffix" title="Código verificador a 5 digitos">
          <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
        </a-tooltip>
      </a-input>
      <a-col flex="auto" class="lg:w-2/3 mx-auto">
        <label class="my-2">Solicitar NIP:</label>
        <a-button type="secondary" shape="circle" class="w-10 h-10 m-2 bg-blue-500 text-white" :disabled="disableSendSms" :loading="sendSmsBusy" @click.prevent="sendSMSNip">
          <a-icon type="message" style="color: rgba(255, 255, 255, 1)" v-show="!sendSmsBusy" />
        </a-button>
        <a-button type="secondary" shape="circle" class="w-10 h-10 m-2 bg-blue-500 text-white" :disabled="disableSendCall" :loading="sendCallBusy" @click.prevent="sendCallNip">
          <a-icon type="phone" style="color: rgba(255, 255, 255, 1)" v-show="!sendCallBusy" />
        </a-button>
        <a-button type="secondary" shape="circle" class="w-10 h-10 m-2 bg-blue-500 text-white" :disabled="disableSendMail" :loading="sendMailBusy" @click.prevent="sendMailNip">
          <a-icon type="mail" style="color: rgba(255, 255, 255, 1)" v-show="!sendMailBusy" />
        </a-button>
        <label class="my-2" id="contador">{{ temporizador }}</label>
      </a-col>
      <a-alert class="mt-2" v-if="confirmationCodeInvalid" type="error" message="El código proporcionado no es válido" closable @close="confirmationCodeInvalid = false" />
    </a-modal>

    <!-- Modal para Cliente Nuevo o Buscar Cliente -->
    <a-modal v-model="showClientTypeConfirmationModal" title="Buscar cliente" @ok.prevent="findClient" okText="Buscar" @cancel="showClientTypeConfirmationModal = false" cancelText="Cancelar">
      <a-form-model ref="formSearch" :model="searchClient" :rules="searchRules">
        <a-row :gutter="25" class="px-1 justify-center">
          <a-col flex="auto" class="w-full lg:float-left lg:w-5/6">
            <p>Buscar por:</p>
            <a-form-model-item prop="id">
              <a-select class="my-4 border-blue-500 border-2 rounded-lg" v-model="searchClient.id" size="large" @change="clientLookup">
                <a-select-option v-for="lookup in clientlookup" :key="lookup.id" :value="lookup.id">{{ lookup.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col flex="auto" class="w-full lg:float-left lg:w-5/6" v-show="showOption">
            <a-form-model-item prop="value">
              <a-input
                class="border-blue-500 border-2 rounded-lg"
                v-model="searchClient.value"
                name="name"
                :placeholder="searchClient.name"
                :max-length="searchClient.length"
                allow-clear
                size="large"
                v-uppercase
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>

    <a-modal v-model="showPreautorizated" title="Buscar preautorizado" @ok.prevent="findPreautorizade" okText="Buscar" @cancel="showPreautorizated = false" cancelText="Cancelar">
      <a-form-model ref="formSearch" :model="searchClient" :rules="searchRules">
        <a-row :gutter="25" class="px-1 justify-center">
          <a-col flex="auto" class="w-full lg:float-left lg:w-5/6">
            <p>Buscar por:</p>
            <a-form-model-item prop="id">
              <a-select class="my-4 border-blue-500 border-2 rounded-lg" v-model="searchClient.id" size="large" @change="clientLookup">
                <a-select-option v-for="lookup in clientlookupP" :key="lookup.id" :value="lookup.id">{{ lookup.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col flex="auto" class="w-full lg:float-left lg:w-5/6" v-show="showOption">
            <a-form-model-item prop="value">
              <a-input
                class="border-blue-500 border-2 rounded-lg"
                v-model="searchClient.value"
                name="name"
                :placeholder="searchClient.name"
                :max-length="searchClient.length"
                allow-clear
                size="large"
                v-uppercase
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>

    <a-modal v-model="showModalSearch" title="Buscar cliente" @cancel.prevent="showModalSearch = false" cancelText="" :footer="null">
      <p v-html="messageModalSearch"></p>
    </a-modal>
    <a-back-top />
  </a-layout-content>
</template>

<script lang="ts">
import { Component, Watch, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { FormModel } from "ant-design-vue";

import debounce from "lodash-es/debounce";
import dayjs from "dayjs";
import { SYSTEM_USER, EMAIL, USER_PORTAL, SESSION_ID } from "@/store/types";
import { API_DATE_FORMAT } from "@/constants/config";
import ProductList from "@/components/ProductList.vue";
import Separator from "@/components/Separator.vue";
import { LeadRequest } from "@/models/requests/lead.interface";
import { PhoneVerification, ConsultaClienteResponse } from "@/models/responses/lead.interface";
import { CatalogueResponse, IncomeTypeResponse, StatusAttributeResponse } from "@/models/responses/catalogue.response.interface";
import { catalogueService } from "@/services/catalogue.service";
import { leadService } from "@/services/lead.service";
import { paytermService } from "@/services/payterm.service";
import { PurposeResponse } from "@/models/responses/purpose.interface";
import { aesDecrypt, aesEncrypt } from "@/utils";
import { variablesService } from "@/services/variables.service";
import { TagReponse } from "@/models/responses/tag.response.interface";
import { LoaderComponent, PluginApi } from "vue-loading-overlay";
import { AxiosError } from "axios";
import { PURPOSE_RESOURCES, CLIENTLOOKUP } from "@/data/home.data";
import { preautorizadoService } from "@/services/preautorizado.service";
import { personService } from "@/services/person.service";
import { imssService } from "@/services/imss.service";

@Component({
  components: {
    ProductList,
    Separator
  }
})
export default class Home extends Vue {
  loading: PluginApi;
  loader: LoaderComponent;
  isDisabled = false;
  mask = false;
  leadCreated = false;
  disableSendSms = true;
  disableSendCall = true;
  disableSendMail = true;
  sendSmsBusy = false;
  sendCallBusy = false;
  sendMailBusy = false;
  disableSendNips = false;
  subcriptionKey = "";
  tokenApim = "";
  leadId = "";
  lead: LeadRequest = {
    purposeId: "",
    // incomeProofId: "",
    requestedAmount: 5_000.0,
    selectedPeriod: 24,
    fixedRecurrentPayment: 0.0,
    calculatedCat: 0.0,
    firstName: "",
    lastName: "",
    mothersLastName: "",
    birthDate: "",
    email: "",
    mobile: "",
    origin: 3, // web
    incomeTypeId: "",
    purposeResources: null,
    userId: ""
  };

  verification: PhoneVerification = {
    intentos: 0,
    statuscode: 1
  };

  leadRules = {
    // incomeProofId: [
    //   {
    //     required: true,
    //     message: "El comprobante de ingresos es requerido",
    //     trigger: "change"
    //   }
    // ],
    firstName: [
      {
        required: true,
        message: "El nombre es requerido",
        trigger: "blur"
      }
    ],
    lastName: [
      {
        required: true,
        message: "El apellido paterno es requerido",
        trigger: "blur"
      }
    ],
    email: [
      {
        required: true,
        message: "El correo electrónico es requerido",
        trigger: "blur"
      },
      {
        type: "email",
        message: "El correo electrónico debe ser válido",
        trigger: "blur"
      }
    ],
    mobile: [
      {
        required: true,
        message: "El número de teléfono es requerido",
        trigger: "blur"
      },
      {
        // eslint-disable-next-line
        validator: (rule: any, value: string, callback: any) => {
          const regex = RegExp("^[0-9]+$"); // or ^\\d+$
          return regex.test(value);
        },
        message: "El número de teléfono no es válido",
        trigger: "blur"
      },
      {
        len: 10,
        message: "El número de teléfono debe ser a 10 dígitos",
        trigger: "blur"
      }
    ],
    incomeTypeId: [
      {
        required: true,
        message: "El tipo de ingreso es requerido",
        trigger: "change"
      }
    ],
    purposeResources: [
      {
        required: true,
        message: "El destino de los recursos es requerido",
        trigger: "change"
      }
    ]
  };

  searchRules = {
    id: [
      {
        required: true,
        message: "El campo es requerido",
        trigger: "blur"
      }
    ],
    value: [
      {
        required: true,
        message: "El campo es requerido",
        trigger: "blur"
      },
      {
        validator: this.isSearchLengthValid,
        message: this.messageSearchLengthValid,
        trigger: "blur"
      },
      {
        validator: this.isSearchValueValid,
        message: this.messageSearchValueValid,
        trigger: "blur"
      }
    ]
  };

  showPreautorizated = false;

  purposes: PurposeResponse[] = [];
  incomeProofs: CatalogueResponse[] = [];
  incomeTypes: IncomeTypeResponse[] = [];
  purposeTypes = PURPOSE_RESOURCES;
  clientlookup = CLIENTLOOKUP;
  clientlookupP = CLIENTLOOKUP.filter((item) => item.name !== "CURP");
  statuscodeLead: StatusAttributeResponse[];
  statuscodeOpp: StatusAttributeResponse[];

  amountConfig = {
    minAmount: 5_000.0,
    maxAmount: 120_000.0,
    step: 1_000.0,
    // TODO: Update marks with new term ranges
    marks: {
      5_000: "5,000",
      20_000: "20,000",
      50_000: "50,000",
      100_000: "100,000",
      120_000: "120,000"
    }
  };

  terms = [24, 48, 72, 96, 120, 144];

  isBusy = false;
  isCodeConfirmationBusy = false;

  noProductSelectedError = false;
  confirmationCode = "";
  showCodeConfirmation = false;
  confirmationCodeInvalid = false;
  calculateBusy = false;

  verificationType: [{ tipo: string; opciones: string }];
  temporizador = "";

  TyCVisible = false;

  Tag: TagReponse = {
    tag: "",
    teamId: "",
    teamName: ""
  };

  showClientTypeConfirmationModal = false;
  searchClient = {
    name: "",
    id: null,
    value: "",
    length: 0
  };
  showOption = false;
  consultaCliente: ConsultaClienteResponse;
  showModalSearch = false;
  messageModalSearch = "";

  isSearchValueValid(rule: unknown, value: string): boolean {
    if (this.searchClient.id) {
      if (this.searchClient.id == 1) {
        const regex1 = RegExp(/^[A-Za-z]{4}[ |\\-]{0,1}[0-9]{6}[ |\\-]{0,1}[0-9A-Za-z]{3}$/);
        return regex1.test(value);
      } else if (this.searchClient.id == 2) {
        const regex2 = RegExp(
          /^[a-zA-Z]{4}((\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8])))|([02468][048]|[13579][26])0229)(H|M)(AS|BC|BS|CC|CL|CM|CS|CH|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|SM|NE)([a-zA-Z]{3})([a-zA-Z0-9\s]{1})\d{1}$/i
        );
        return regex2.test(value);
      } else if (this.searchClient.id == 3) {
        const regex3 = RegExp("^[0-9]+$");
        return regex3.test(value);
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  isSearchLengthValid(rule: unknown, value: string): boolean {
    if (this.searchClient.id) {
      if (value.length != this.searchClient.length) {
        return false;
      } else return true;
    }
    return true;
  }

  @Watch("lead.requestedAmount")
  onAmountChanged(): void {
    this.onDebouncedAmountChanged();
  }

  setTermRanges(min: number, max: number): void {
    if (this.lead.requestedAmount < 15000) {
      this.recalculateTerms(min, 72);
    } else {
      this.recalculateTerms(48, max);
    }
  }

  recalculateTerms(min: number, max: number): void {
    this.terms = [];
    let currTerm = min;
    while (currTerm <= max) {
      this.terms.push(currTerm);
      currTerm += 24;
    }

    if (!this.terms.includes(this.lead.selectedPeriod)) {
      this.lead.selectedPeriod = this.terms[0];
    }
  }

  onDebouncedAmountChanged(): void {
    // https://davidwalsh.name/javascript-debounce-function
    // https://lodash.com/docs/4.17.15#debounce
    const prod = this.purposes.find((p) => p.id == this.lead.purposeId);
    if (prod) {
      this.setTermRanges(prod.minTerm, prod.maxTerm);
    }

    this.calculatePayTerm();
  }

  onProductChanged(value: string): void {
    if (value === "Prestanómina") {
      this.showClientTypeConfirmationModal = true;
    } else {
      this.showPreautorizated = true;
      const found = this.purposes.find((p) => p.name.toLowerCase() == value.toLowerCase());
      if (found) {
        this.noProductSelectedError = false;

        this.lead.purposeId = found.id;

        this.amountConfig.minAmount = found.minAmount;
        this.amountConfig.maxAmount = found.maxAmount;

        if (this.lead.requestedAmount > found.maxAmount) {
          this.lead.requestedAmount = found.maxAmount;
        }

        // this.recalculateTerms(found.minTerm, found.maxTerm);
        this.setTermRanges(found.minTerm, found.maxTerm);
        this.calculatePayTerm();
      }
    }
  }

  onPayPeriodChange(e: { target: HTMLInputElement }): void {
    try {
      if (e !== null && e.target != null) {
        this.calculatePayTerm();
      }
    } catch (error) {
      this.showError(error);
    }
  }

  onIncomeTypeChange(): void {
    if (this.lead.requestedAmount) {
      this.calculatePayTerm();
    }
  }

  onBirthDateChange(date: dayjs.Dayjs /*moment.Moment*/): void {
    if (date && date.isValid()) {
      this.lead.birthDate = date.format(API_DATE_FORMAT);
    }
  }

  formatMoney(value: number): string {
    return `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  async calculatePayTerm(): Promise<void> {
    if (!this.lead.incomeTypeId) return;

    const incomeType = this.incomeTypes.find((i) => i.id == this.lead.incomeTypeId);
    if (!incomeType?.ordinaryRate) return;
    this.calculateBusy = true;
    const payload = {
      amount: this.lead.requestedAmount,
      term: this.lead.selectedPeriod,
      ordinaryRate: incomeType.ordinaryRate,
      tax: 0.0
    };

    let res = await paytermService.calculate(payload);
    const cat = res.cat;

    payload.tax = 16.0;
    res = await paytermService.calculate(payload);

    this.lead.fixedRecurrentPayment = res.payment;
    this.lead.calculatedCat = cat;
    this.calculateBusy = false;
  }

  verifyNipCode(): void {
    this.confirmationCodeInvalid = false;
    this.isCodeConfirmationBusy = true;

    setTimeout(async () => {
      try {
        //await this.$recaptchaLoaded();
        // FIXME: reCaptcha token should be sent to backend along with findConfirmation request
        // That way, backend validates the token before sending SMS and frontend does not know anything about it (it should also validate the action matches)

        //TODO: Se comenta el Recatch para pruebas
        // const action = "nip_auth";
        // const token = await this.$recaptcha(action);
        // const tokenValidation = await leadService.siteVerification(token);
        // if (!tokenValidation.success) return false;
        // if (tokenValidation.action !== action) return false;
        // if (tokenValidation.score <= 0.3) return false;

        const confirmed = await leadService.findConfirmation(this.leadId, this.confirmationCode, "nipenviado");
        if (confirmed) {
          await leadService.saveConfirmation(this.leadId, this.confirmationCode);

          const id = aesEncrypt(this.leadId);
          this.$router.push({
            name: "Profiling",
            query: { tracking: id }
          });
        } else {
          this.confirmationCodeInvalid = true;
        }
      } catch (error) {
        this.showError(error);
      } finally {
        this.isCodeConfirmationBusy = false;
      }
    }, 1000);
  }

  async sendSMSNip(): Promise<void> {
    try {
      this.sendSmsBusy = true;
      this.disableSendSms = true;
      await leadService.detonatePlugin(this.leadId, { rs_detonacodigoverificador: true });
      this.sendSmsBusy = false;
      this.updateTemp();
    } catch (error) {
      this.showError(error);
      await this.disabledButtonsNip();
      this.sendSmsBusy = false;
    }
  }

  async sendCallNip(): Promise<void> {
    try {
      this.sendCallBusy = true;
      this.disableSendCall = true;
      await leadService.detonatePlugin(this.leadId, { rs_detonacodigoverificador: true });
      this.sendCallBusy = false;
      this.updateTemp();
    } catch (error) {
      this.showError(error);
      await this.disabledButtonsNip();
      this.sendCallBusy = false;
    }
  }

  async sendMailNip(): Promise<void> {
    try {
      this.sendMailBusy = true;
      this.disableSendMail = true;
      await leadService.detonatePlugin(this.leadId, { rs_detonacodigoverificador: true });
      this.sendMailBusy = false;
    } catch (error) {
      this.showError(error);
      await this.disabledButtonsNip();
      this.sendMailBusy = false;
    }
  }

  async updateTemp(): Promise<void> {
    try {
      var tiempoRestante = Number.parseInt(await variablesService.getEnviromentVariable("rs_tiempoespera_botonesverificacion"));
      const intervalo = await setInterval(async () => {
        const minutos = Math.floor(tiempoRestante / 60);
        const segundos = tiempoRestante % 60;

        this.temporizador = `${String(minutos).padStart(2, "0")}:${String(segundos).padStart(2, "0")}`;
        if (tiempoRestante <= 0) {
          clearInterval(intervalo);
          this.temporizador = "";
          this.disabledButtonsNip();
        }
        tiempoRestante--;
      }, 1000); // 1000 milisegundos = 1 segundo
    } catch (error) {
      this.showError(error);
    }
  }

  async disabledButtonsNip(): Promise<void> {
    try {
      this.verification = await leadService.getVerificacion(this.leadId, "1");

      if (this.verification.statuscode == 717810002) {
        this.disableSendSms = true;
        this.disableSendCall = true;
        this.disableSendMail = true;
        return;
      }

      if (this.verification.intentos == 5) this.disableSendSms = true;

      let verificacionTelefono = await variablesService.getEnviromentVariable("rs_verificaciontelefono_tipointentos");
      this.verificationType = JSON.parse(verificacionTelefono);
      this.verificationType.forEach((veri) => {
        if (veri.tipo == "sms") {
          if (veri.opciones.includes(this.verification.intentos.toString())) {
            this.disableSendSms = false;
            this.disableSendCall = true;
            this.disableSendMail = true;
            return;
          }
        } else if (veri.tipo == "llamada") {
          if (veri.opciones.includes(this.verification.intentos.toString())) {
            this.disableSendSms = true;
            this.disableSendCall = false;
            this.disableSendMail = true;
            return;
          }
        } else if (veri.tipo == "correo") {
          if (veri.opciones.includes(this.verification.intentos.toString())) {
            this.disableSendSms = true;
            this.disableSendCall = true;
            this.disableSendMail = false;
            return;
          }
        }
      });
    } catch (error) {
      this.showError(error);
    }
  }

  async submit(): Promise<void> {
    this.loader = this.loading.show();
    try {
      if (!this.lead.purposeId) {
        this.noProductSelectedError = true;
        return;
      }

      if (this.calculateBusy) {
        this.showInfo("Espere a que termine de realizar el cálculo del CAT y Pago fijo.");
        return;
      }

      //await this.$recaptchaLoaded();
      // FIXME: reCaptcha token should be sent to backend along with findUnique request
      // That way, backend validates the token before sending SMS and frontend does not know anything about it (it should also validate the action matches)

      // TODO: Se comenta el recatcha para pruebas de Call Center
      // const action = "lead_create";
      // const token = await this.$recaptcha(action);
      // const tokenValidation = await leadService.siteVerification(token);
      // if (!tokenValidation.success) return;
      // if (tokenValidation.action !== action) return;
      // if (tokenValidation.score <= 0.3) return;

      let waitTimeDisableSendSms = 0;
      (this.$refs.form as FormModel).validate(async (valid) => {
        if (valid) {
          try {
            this.isBusy = true;
            if (this.leadCreated == false) {
              const existant = await leadService.findUnique(this.lead);
              if (existant) {
                this.showControlledError("Ya cuenta con una solicitud de crédito en proceso, favor de continuar con el folio otorgado", "Solicitud de crédito en proceso");
              } else {
                if (this.$store.getters.getSystemUser !== "") this.lead.ownerId = this.$store.getters.getSystemUser;
                if (this.$store.getters.getUser !== "") this.lead.userId = this.$store.getters.getUser;
                waitTimeDisableSendSms = await this.getTimeout();
                this.leadId = await leadService.create(this.lead);
                this.leadCreated = true;

                const valid = await leadService.validateLogs(this.leadId, "lead");
                if (!valid) {
                  this.showControlledError("El teléfono celular no es un número móvil válido.");
                  return;
                }

                //await leadService.sendSms(this.leadId, "nipenviado");
                this.disabledButtonsNip();
                this.showCodeConfirmation = true;
              }
            } else {
              await leadService.updatePhone(this.leadId, this.lead.mobile);
              const valid = await leadService.validateLogs(this.leadId, "lead");
              if (!valid) {
                this.showControlledError("El teléfono celular no es un número móvil válido.");
                return;
              }
              this.disabledButtonsNip();

              waitTimeDisableSendSms = await this.getTimeout();
              //await leadService.sendSms(this.leadId, "nipenviado");
              this.showCodeConfirmation = true;
            }
          } catch (error) {
            waitTimeDisableSendSms = 0;
            this.showError(error);
          } finally {
            this.disableSendNips = true;
            this.isBusy = false;
            setTimeout(() => {
              this.disableSendNips = false;
            }, waitTimeDisableSendSms);
          }
        } else {
          return false;
        }
      });
    } catch (error) {
      this.showError(error);
    } finally {
      this.loader.hide();
    }
  }

  async getTimeout(): Promise<number> {
    let waitTimeDisableSendSms = await variablesService.timeWaitSendSms("rs_timersms");
    if (!waitTimeDisableSendSms || waitTimeDisableSendSms == null) {
      this.showControlledError("La variable rs_timersms no está configurada.");
      return 0;
    }
    waitTimeDisableSendSms = waitTimeDisableSendSms * 1000;
    return waitTimeDisableSendSms;
  }

  showError(error: AxiosError<Error>): void {
    const errorTmp: any = error.response?.data;
    this.$error({
      title: "Ocurrió un error",
      content: errorTmp?.error?.message,
      centered: true,
      okText: "Aceptar"
    });
  }

  showControlledError(error: string, title?: string): void {
    if (!title) title = "Ocurrió un error";
    this.$error({
      title: "Ocurrió un error",
      content: error,
      centered: true,
      okText: "Aceptar"
    });
  }

  showInfo(info: string): void {
    this.$info({
      title: "",
      content: info,
      centered: true,
      okText: "Aceptar"
    });
  }

  created(): void {
    // debouncing instance method
    this.onDebouncedAmountChanged = debounce(this.onDebouncedAmountChanged, 1000);
  }

  async mounted(): Promise<void> {
    this.loading = this.$loading;
    this.isDisabled = true;
    try {
      this.loader = this.loading.show();
      this.purposes = await catalogueService.getAllPurposes();
      this.incomeProofs = await catalogueService.getAllIncomeProofs();
      this.incomeTypes = await catalogueService.getAllIncomeTypes();

      await variablesService.schedule();
      const parameterTag = this.$route.query.user;

      this.statuscodeLead = await catalogueService.getRetrieveStatusAttributeMetadata("lead");
      this.statuscodeOpp = await catalogueService.getRetrieveStatusAttributeMetadata("opportunity");

      this.Tag = await variablesService.getBrokers(parameterTag as string);
      this.disableSendSms = false;
      this.disableSendCall = false;
      this.disableSendMail = false;

      this.$store.commit("SET_PLD_STATUS", false);
    } catch (error) {
      this.showError(error);
    } finally {
      this.isDisabled = false;
      this.loader.hide();
    }
  }

  async computed(): Promise<void> {
    mapGetters([USER_PORTAL, EMAIL, SYSTEM_USER, SESSION_ID]);
  }

  async findClient(): Promise<void> {
    (this.$refs.formSearch as FormModel).validate(async (valid) => {
      if (valid) {
        try {
          this.loader = this.loading.show();

          const request = {
            RFC: this.searchClient.id == 1 ? this.searchClient.value : null,
            CURP: this.searchClient.id == 2 ? this.searchClient.value : null,
            NumeroCliente: this.searchClient.id == 3 ? this.searchClient.value : null,
            tipoCliente: 2
          };

          this.consultaCliente = await leadService.ConsultaClienteLibertad(request);
          if (this.consultaCliente.code == -1) {
            const entity = aesEncrypt("prospecto");
            this.$router.push({
              name: "HomeImss",
              query: { ent: entity }
            });
          } else if (this.consultaCliente.code == 0) {
            /* if (this.consultaCliente?.status && this.consultaCliente?.campaign) {
              this.selectScenarie(this.consultaCliente, request.NumeroCliente, 1);
            } else { */
            const client = aesEncrypt(this.consultaCliente.customers[0].id);
            const entity = aesEncrypt("oportunidad");
            this.$router.push({
              name: "HomeImss",
              query: { ent: entity, client: client }
            });
            /* } */
          } else if (this.consultaCliente.code == 1) {
            let clients = "";
            this.consultaCliente.customers.forEach((c) => {
              clients += c.name + "\n";
            });

            this.messageModalSearch = this.consultaCliente.message.replace("{customers}", clients);
            this.showClientTypeConfirmationModal = false;
            this.searchClient = { name: "", id: null, value: "", length: 0 };
            this.showOption = false;
            this.showModalSearch = true;
          } else if (this.consultaCliente.code == 2 || this.consultaCliente.code == 3) {
            let folios = ``;
            this.consultaCliente.leads?.forEach((c) => {
              folios += `<br>  - ${c.number} - ${this.statuscodeLead.find((s) => s.value == c.status)?.name}`;
            });
            this.consultaCliente.opps?.forEach((c) => {
              folios += `<br>  - ${c.number} - ${this.statuscodeOpp.find((s) => s.value == c.status)?.name}`;
            });

            this.messageModalSearch = `${this.consultaCliente.message}<br>${folios}`;
            this.showClientTypeConfirmationModal = false;
            this.searchClient = { name: "", id: null, value: "", length: 0 };
            this.showOption = false;
            this.showModalSearch = true;
          } else {
            this.showControlledError(this.consultaCliente.message);
          }
        } catch (error) {
          this.showError(error);
        } finally {
          this.loader.hide();
        }
      }
    });
  }

  async selectScenarie(consultaCliente: ConsultaClienteResponse, numCliente: string, tipoProyecto: number): Promise<void> {
    const status = consultaCliente.status;
    const camp = Number.parseInt(consultaCliente.campaign);

    //Invitacion
    if (tipoProyecto == 1 && camp == 717810002 && status) {
      this.GoToPreautorizade();
      return;
    }

    //Escenario 1
    if (status == "I" && camp == 717810001) {
      this.$confirm({
        title: "Cliente con oferta preautorizada sujeto a BC",
        content: "¿Deseas continuar con la oferta?",
        centered: true,
        okText: "Sí",
        cancelText: "No",
        onOk: () => {
          if (tipoProyecto == 0 || tipoProyecto == 1) this.GoToPreautorizade();
        },
        onCancel: () => {
          if (tipoProyecto == 1) this.GoToExistantClient(numCliente);
          else this.GoToIMSS(numCliente, "oportunidad");
        }
      });
    } else if (status == "A" && camp == 717810000) {
      //Escenario 2
      if (tipoProyecto == 0 || tipoProyecto == 1) this.GoToPreautorizade();
    } else if (status == "I" && camp != 717810001) {
      //Escenario 3
      this.showControlledError("La solicitud no cumple con los lineamientos");
    } else if (status == "A" && camp != 717810000) {
      //Escenario 4
      //this.showControlledError("La solicitud no cumple con los lineamientos");
      this.GoToPreautorizade();
    } else {
      //Ningun escenario
      return;
    }
  }

  clientLookup(): void {
    if (this.searchClient.id) {
      var type = this.clientlookup.find((c) => c.id == this.searchClient.id);
      this.searchClient.name = type.name;
      this.searchClient.length = type.length;
      this.showOption = true;
      this.searchClient.value = "";
    }
  }

  messageSearchLengthValid(): string {
    return this.searchClient.name + " debe de tener " + this.searchClient.length + " carácteres";
  }

  messageSearchValueValid(): string {
    return this.searchClient.name + " no es válido";
  }

  validateRFC(value) {
    const rfcRegex = /([A-ZÑ&]{4})\d{6}([A-Z0-9]{3})?/;
    return rfcRegex.test(value);
  }

  validateCURP(value) {
    const curpRegex = /^[A-Z]{4}\d{6}[HM]{1}[A-Z]{5}\d{2}$/;
    return curpRegex.test(value);
  }

  validarBusqueda(value) {
    let isValid = false;

    if (this.searchClient.name === "RFC") {
      isValid = this.validateRFC(value);
    } else if (this.searchClient.name === "CURP") {
      isValid = this.validateCURP(value);
    }

    if (!isValid) {
      this.$message.error("El valor ingresado no es válido.");
    } else {
      this.$message.success("El valor es válido.");
    }
    return isValid;
  }

  async findPreautorizade(): Promise<void> {
    (this.$refs.formSearch as FormModel).validate(async (valid) => {
      if (valid) {
        try {
          this.loader = this.loading.show();
          const request = {
            RFC: this.searchClient.id == 1 ? this.searchClient.value : null,
            NumeroCliente: this.searchClient.id == 3 ? this.searchClient.value : null,
            tipoCliente: 1
          };

          /*let preautorizado = null;
          let numeroCliente = "";
          if (this.searchClient.id == 3) {
            preautorizado = await preautorizadoService.consultaPreautorizado(request);
            numeroCliente = request.NumeroCliente;
          } else {
            const requestCC = {
              RFC: this.searchClient.id == 1 ? this.searchClient.value : null,
              CURP: "",
              NumeroCliente: ""
            };
            const nc = await preautorizadoService.consultaNumeroCliente(requestCC);
            if (nc && nc.numeroCliente != "") {
              const request = {
                RFC: "",
                NumeroCliente: nc.numeroCliente
              };
              preautorizado = await preautorizadoService.consultaPreautorizado(request);
              numeroCliente = nc.numeroCliente;
            }
          } */

          /* if (preautorizado.code == 500) {
            this.showControlledError(preautorizado?.message);
          } else { */
          /* let request = {
            RFC: "",
            CURP: "",
            NumeroCliente: numeroCliente
          }; */

          this.showPreautorizated = false;
          this.consultaCliente = await leadService.ConsultaClienteLibertad(request);
          if (this.consultaCliente.code == 0) {
            //this.selectScenarie(this.consultaCliente, request.NumeroCliente, 1);
            this.showGoTo(this.consultaCliente, request.NumeroCliente, 1);
          } else if (this.consultaCliente.code == 1) {
            let clients = "";
            this.consultaCliente.customers.forEach((c) => {
              clients += c.name + "\n";
            });

            this.messageModalSearch = this.consultaCliente.message.replace("{customers}", clients);
            this.showClientTypeConfirmationModal = false;
            this.searchClient = { name: "", id: null, value: "", length: 0 };
            this.showOption = false;
            this.showModalSearch = true;
          } else if (this.consultaCliente.code == 2 || this.consultaCliente.code == 3) {
            let folios = ``;
            this.consultaCliente.leads?.forEach((c) => {
              folios += `<br>  - ${c.number} - ${this.statuscodeLead.find((s) => s.value == c.status)?.name}`;
            });
            this.consultaCliente.opps?.forEach((c) => {
              folios += `<br>  - ${c.number} - ${this.statuscodeOpp.find((s) => s.value == c.status)?.name}`;
            });

            this.messageModalSearch = `${this.consultaCliente.message}<br>${folios}`;
            this.showClientTypeConfirmationModal = false;
            this.searchClient = { name: "", id: null, value: "", length: 0 };
            this.showOption = false;
            this.showModalSearch = true;
          } else if (this.consultaCliente.code == 4) {
            this.showGoTo(this.consultaCliente, request.NumeroCliente, 1);
            /* const id = aesEncrypt(this.consultaCliente.lead[0].id);
            const ent = aesEncrypt("prospecto");
            this.$router.push({
              name: "Profiling",
              query: { tracking: id, code: "", ent: ent }
            }); */
          } else if (this.consultaCliente.code == 500) {
            this.showControlledError(this.consultaCliente.message);
          }
          /* } */
        } catch (error) {
          this.showError(error);
        } finally {
          this.loader.hide();
        }
      }
    });
  }

  GoToPreautorizade() {
    const client = aesEncrypt(this.consultaCliente.customers[0].id);
    const entity = aesEncrypt("oportunidad");
    this.$router.push({
      name: "Preautorizados",
      query: { ent: entity, client: client }
    });
    return;
  }

  async GoToExistantClient(numeroCliente: string) {
    const loader = this.$loading.show();
    try {
      //const res = await leadService.getContactProfiling(this.consultaCliente.customers[0].id);
      const lead = await leadService.createExistantClient(numeroCliente);

      const id = aesEncrypt(lead);
      const ent = aesEncrypt("prospecto");
      this.$router.push({
        name: "Profiling",
        query: { tracking: id, code: "", ent: ent }
      });
      return;
    } catch (e) {
      this.showError(e);
    } finally {
      loader.hide();
    }
  }

  async GoToIMSS(entity: string, client: string) {
    const loader = this.$loading.show();
    try {
      this.$router.push({
        name: "HomeImss",
        query: { ent: entity, client: client }
      });
    } catch (e) {
      this.showError(e);
    } finally {
      loader.hide();
    }
  }

  async showGoTo(consultaCliente: ConsultaClienteResponse, numCliente: string, tipoProyecto: number) {
    const ofertaPre = await preautorizadoService.consultaOfertaPreautorizado(numCliente);

    if (ofertaPre.Oferta) {
      const h = this.$createElement;

      this.$confirm({
        centered: true,
        width: 600,
        okText: "Continuar con Oferta Preautorizada",
        cancelText: "Continuar con nuevo Digital",
        content: h("div", [
          h("p", { style: { fontWeight: "500", marginBottom: "8px" } }, "Se encontró una oferta preautorizada para este cliente"),
          h("p", `• Monto: $${ofertaPre.Oferta.Monto}`),
          h("p", `• Plazo: ${ofertaPre.Oferta.Plazo}`),
          h("p", `• Tasa de interés: ${ofertaPre.Oferta.TasaInteres}`),
          h("p", `• Tipo de oferta: ${ofertaPre.Oferta.TipoOferta}`),
          h("p", `• Tipo de cliente: ${ofertaPre.Oferta.TipoCliente}`)
        ]),
        onOk: async () => {
          this.selectScenarie(consultaCliente, numCliente, tipoProyecto);
        },
        onCancel: async () => {
          this.showConfirmNewDigital(numCliente, consultaCliente);
        }
      });
    } else {
      if (this.consultaCliente.code == 4) {
        const id = aesEncrypt(this.consultaCliente.lead[0].id);
        const ent = aesEncrypt("prospecto");
        this.$router.push({
          name: "Profiling",
          query: { tracking: id, code: "", ent: ent }
        });
      } else this.selectScenarie(consultaCliente, numCliente, tipoProyecto);
    }
  }

  async showConfirmNewDigital(numCliente: string, consultaCliente: ConsultaClienteResponse) {
    this.$confirm({
      centered: true,
      width: 600,
      okText: "Si",
      cancelText: "No",
      content: "Estas siendo dirigido al proceso de cliente recurrente para calcular una nueva oferta. ¿Desea continuar?",
      onOk: async () => {
        if (consultaCliente.code == 4) {
          const id = aesEncrypt(consultaCliente.lead[0].id);
          const ent = aesEncrypt("prospecto");
          this.$router.push({
            name: "Profiling",
            query: { tracking: id, code: "", ent: ent }
          });
        } else {
          const leadId = await leadService.createDigitalNew(numCliente);
          const id = aesEncrypt(leadId);
          const ent = aesEncrypt("prospecto");
          this.$router.push({
            name: "Profiling",
            query: { tracking: id, code: "", ent }
          });
        }
      },
      onCancel: async () => {
        return;
      }
    });
  }
}
</script>

<style lang="scss">
.ant-slider-rail {
  background-color: #e1e1e1 !important;
}

.ant-slider-track {
  background-color: #e59733 !important;
  height: 8px !important;
  top: 2px !important;
}

.ant-slider-dot-active {
  background-color: #fab43d !important;
  border-color: #fab43d !important;
  height: 12px !important;
  top: -4px !important;
  width: 12px !important;
}

.ant-slider-handle {
  background-color: #fab43d !important;
  border-color: #fab43d !important;
  height: 24px !important;
  top: -1px !important;
  width: 24px !important;
}

.ant-input {
  border: 0 !important;
  border-radius: 8px !important;
}

.ant-radio-button-wrapper-checked {
  background-color: #fab43d !important;
  border-color: #fab43d !important;
  box-shadow: none !important;
}

label.ant-radio-button-wrapper.ant-radio-button-wrapper-checked::before {
  background-color: #fab43d !important;
}

.ant-select-selection {
  border: 0 !important;
  border-radius: 8px !important;
}

.ant-btn {
  background-color: #fab400 !important;
}

.ant-btn {
  color: #fff !important;
}

.ant-btn:hover,
.ant-btn:focus {
  color: #fff !important;
}

.ant-btn-primary {
  background-color: #fab43d !important;
  border: 0 !important;
}

.ant-btn-primary :hover {
  background-color: #e59733 !important;
  border: 0 !important;
}

#modalTyC .ant-modal {
  top: 30px;
  width: 920px !important;
}

#modalTyC .ant-btn {
  display: none !important;
}

#modalTyC .ant-btn.ant-btn-primary {
  display: block !important;
}

.ant-calendar-header .ant-calendar-month-select,
.ant-calendar-month-panel-year-select-content,
.ant-calendar-year-panel-decade-select-content,
.ant-calendar-header .ant-calendar-year-select {
  text-decoration: underline;
}

.bg-blue-500 {
  background-color: #004593 !important;
}

.bg-blue-500:hover {
  background-color: #003593 !important;
  font-weight: bold !important;
}

.bg-blue-500:disabled {
  background-color: rgba(0, 69, 147, 0.6) !important;
}

.bg-yellow-500 {
  background-color: #fab400 !important;
}

.bg-yellow-500:hover {
  background-color: #faa400 !important;
  font-weight: bold !important;
}

.bg-yellow-500:disabled {
  background-color: rgba(250, 180, 0, 0.6) !important;
}

.bg-gray-200 {
  background-color: #fff !important;
}

.text-blue-500 {
  color: #004593 !important;
}

.border-blue-500 {
  border: 2px solid #004593 !important;
  border-color: #004593 !important;
}

.text-red {
  color: #f00;
}
</style>
